import React from "react";
import { connect } from "react-redux";
import moment from "moment";
import auth from "../api/auth";
import Button from "./subcomponents/controls/button";
import system from "../api/system";
import notification from "./subcomponents/notification";
import config from "../config";
import LogoutForm from "./logoutform";
import sounds from "./sounds";

class Dashboard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      pulse: false,
      show_pulse_label: false,
      sound_arm_once: false,
    };
  }
  componentWillReceiveProps(nextProps) {
    let self = this;
    if (nextProps.pulse !== this.state.pulse) {
      this.setState({ pulse: !this.state.pulse });
      this.setState({ show_pulse_label: true });
      setTimeout(function () {
        self.setState({ show_pulse_label: false });
      }, 1000);
    }
    if (this.state.sound_arm_once === false && nextProps.system_armed) {
      this.setState({ sound_arm_once: true });
      sounds.play("arm");
    }
    if (this.state.sound_arm_once === true && !nextProps.system_armed) {
      this.setState({ sound_arm_once: false });
      sounds.play("disarm");
    }
  }
  config_mode() {
    if (this.props.config_mode) {
      return <span>CONFIG MODE IS ACTIVE: {this.props.access_code}</span>;
    } else {
      return null;
    }
  }
  controllers() {
    let controllers_count = this.props.controllers_online
      ? this.props.controllers_online.length
      : 0;
    //console.log(this.props.controllers_online);
    return <span>CONTROLLERS: {controllers_count}</span>;
  }
  need_restart() {
    if (this.props.need_restart) {
      return (
        <span className="system_restart">
          <Button
            label="Please restart"
            name="system_restart_button"
            onClick={this.restartSystem.bind(this)}
          />
        </span>
      );
    } else {
      return null;
    }
  }
  showTimeout() {
    if (!config.auto_relogin && !config.auto_refresh) {
      return <span>TIMEOUT: {this.props.session_timeout}</span>;
    } else {
      return null;
    }
  }
  restartSystem() {
    this.props.setSystemRestart();
    system.remote_command(
      { type: "system", command: "system_restart" },
      function (error, response) {
        if (error) notification.error(error.message);
      }
    );
  }
  render() {
    let device_class = "waiting";
    if (this.state.show_pulse_label) device_class = "pulse";
    if (auth.isAuth()) {
      return (
        <div className="dashboard_wrap">
          <div className="dashboard">
            <div className="system_info">
              <span className={device_class}>{this.props.device_name}</span>
              <span> {this.props.info} ({this.props.role}) - {this.props.company_name}</span>
              <span>TIME: {this.props.time}</span>
              {this.controllers()}
              {this.showTimeout()}
              {this.need_restart()}
            </div>
          </div>
        </div>
      );
    } else {
      return <LogoutForm />;
    }
  }
}

function mapStateToProps(state) {
  let session_timeout = false;
  if (state.authR.token.token_expires) {
    session_timeout = moment(state.authR.token.token_expires).format(
      "YYYY-MM-DD, HH:mm:ss"
    );
  }
  return {
    device_name: state.systemR.device_name,
    user_id: state.authR.user.user_id,
    info: state.authR.user.info,
    role: state.authR.user.role,
    company_name: state.authR.user.company_name,
    time: state.systemR.server_time,
    config_mode: state.systemR.config_data.config_mode,
    need_restart: state.systemR.config_data.need_restart,
    access_code: state.systemR.config_data.access_code
      ? " last access code: " + state.systemR.config_data["access_code"]
      : "",
    session_timeout: session_timeout,
    pulse: state.systemR.pulse,
    controllers_online: state.systemR.controllers_online,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    setSystemRestart() {
      dispatch({
        type: "SYSTEM_RESTART",
        remote_command: {
          type: "system",
          command: "system_restart",
        },
      });
    },
  };
}

export default Dashboard = connect(
  mapStateToProps,
  mapDispatchToProps
)(Dashboard);
